import React from "react";
import { Employee } from "../../../../Utilities";
import * as PersonComponents from "../../Person";

export type IconEmployee = Pick<Employee, "id"> & {
	person: PersonComponents.IconPerson;
};

export type EmployeeMultiIcon = Omit<PersonComponents.PersonMultiIconProps, "people"> & {
	employees: IconEmployee[];
};

export function EmployeeMultiIcon({ employees, ...props }: EmployeeMultiIcon) {
	const people = React.useMemo(() => employees.map((e) => e.person), [employees]);

	return <PersonComponents.PersonMultiIcon people={people} {...props} />;
}

export type EmployeeAdditionalCountIconProps = PersonComponents.PersonAdditionalCountIconProps;

export function EmployeeAdditionalCountIcon(props: EmployeeAdditionalCountIconProps) {
	return <PersonComponents.PersonAdditionalCountIcon {...props} />;
}

export type EmployeeIconProps = Omit<PersonComponents.PersonIconProps, "person"> & {
	employee: IconEmployee;
};

export function EmployeeIcon({ employee, ...props }: EmployeeIconProps) {
	return <PersonComponents.PersonIcon person={employee.person} {...props} />;
}

export type EmployeeIconWithFullModalProps = Omit<PersonComponents.PersonIconWithFullModalProps, "person"> & {
	employee: IconEmployee;
};

export function EmployeeIconWithFullModal({ employee, ...props }: EmployeeIconWithFullModalProps) {
	return <PersonComponents.PersonIconWithFullModal person={employee.person} {...props} />;
}

export type EmployeesCondensedListProps = Omit<PersonComponents.PeopleCondensedListProps, "people"> & {
	employees: IconEmployee[];
};

export function EmployeesCondensedList({ employees, ...props }: EmployeesCondensedListProps) {
	const people = React.useMemo(() => employees.map((e) => e.person), [employees]);

	return <PersonComponents.PeopleCondensedList people={people} {...props} />;
}
